import React, { useState, useEffect } from "react";

function Transactions() {
  const [transactions, setTransactions] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortOption, setSortOption] = useState("date_desc");
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const itemsPerPage = 10;

  // Fetch transactions
  const fetchTransactions = async () => {
    const match = document.cookie.match(new RegExp("(^| )token=([^;]+)"));

    try {
      const response = await fetch("https://liquidationapi.dallasagsmith.workers.dev/transaction", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: match[2] }),
      });

      if (response.status === 200) {
        const data = await response.json();
        const mergedMap = {};
        data.forEach((item) => {
          const key = `${item.title}||${item.description || ""}||${item.cost}||${item.sell}||${item.purchased_date}||${item.sold_date}||${item.notes || ""}`;
          if (mergedMap[key]) {
            mergedMap[key].quantity += 1;
          } else {
            mergedMap[key] = { ...item, quantity: 1 };
          }
        });
        setTransactions(Object.values(mergedMap));
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

  // Filter & sort
  const filteredTransactions = transactions.filter(
    (t) =>
      t.title.toLowerCase().includes(search.toLowerCase()) ||
      (t.description && t.description.toLowerCase().includes(search.toLowerCase()))
  );

  const sortedTransactions = [...filteredTransactions].sort((a, b) => {
    switch (sortOption) {
      case "title_asc": return a.title.localeCompare(b.title);
      case "title_desc": return b.title.localeCompare(a.title);
      case "cost_asc": return Number(a.cost) - Number(b.cost);
      case "cost_desc": return Number(b.cost) - Number(a.cost);
      case "sell_asc": return Number(a.sell) - Number(b.sell);
      case "sell_desc": return Number(b.sell) - Number(a.sell);
      case "purchased_asc": return new Date(a.purchased_date) - new Date(b.purchased_date);
      case "purchased_desc": return new Date(b.purchased_date) - new Date(a.purchased_date);
      case "sold_asc": return new Date(a.sold_date) - new Date(b.sold_date);
      case "sold_desc": return new Date(b.sold_date) - new Date(a.sold_date);
      default: return 0;
    }
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedTransactions.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(sortedTransactions.length / itemsPerPage);

  return (
    <div className="page-container">
      <h2>Transactions</h2>

      {/* Search + Sort */}
      <div className="card" style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
        <input
          type="text"
          placeholder="Search transactions..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
          style={{ flex: 1 }}
        />
        <select
          value={sortOption}
          onChange={(e) => setSortOption(e.target.value)}
          style={{ padding: "10px", borderRadius: "6px" }}
        >
          <option value="title_asc">Title ↑</option>
          <option value="title_desc">Title ↓</option>
          <option value="cost_asc">Cost ↑</option>
          <option value="cost_desc">Cost ↓</option>
          <option value="sell_asc">Sell ↑</option>
          <option value="sell_desc">Sell ↓</option>
          <option value="purchased_asc">Purchased ↑</option>
          <option value="purchased_desc">Purchased ↓</option>
          <option value="sold_asc">Sold ↑</option>
          <option value="sold_desc">Sold ↓</option>
        </select>
      </div>

      {/* Transaction list */}
      <div className="transaction-list">
        {currentItems.length === 0 ? (
          <div className="spinner"></div>
        ) : (
          currentItems.map((t, index) => (
            <div
              className="transaction-card"
              key={index}
              onClick={() => setSelectedTransaction(t)}
              style={{ cursor: "pointer" }}
            >
              <div className="transaction-info">
                <div className="transaction-title">
                  {t.title} {t.quantity > 1 && `x${t.quantity}`}
                </div>
                <div className="transaction-desc">{t.description}</div>
              </div>
              <div className="transaction-amounts">
                {t.sell > 0 ? ((t.sell - t.cost) >= 0 ? (<div className="transaction-cost" style={{color: "green"}}>+{(((t.sell - t.cost) / t.cost) * 100).toFixed(2)}%</div>) : (<div className="transaction-cost" style={{color: "red"}}>{(((t.sell - t.cost) / t.cost) * 100).toFixed(2)}%</div>)) : ''}

                <div className="transaction-sell">{t.sell > 0 ? `Sell: $${Number(t.sell*t.quantity).toFixed(2)}` : 'DONATION'}</div>
                <div className="transaction-dates">{t.sold_date}</div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "20px", gap: "10px" }}>
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}

      {/* Modal Popup */}
      {selectedTransaction && (
        <div
            style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            padding: "10px" // ensure some spacing for mobile
            }}
            onClick={() => setSelectedTransaction(null)}
        >
            <div
            className="card"
            style={{
                padding: "20px",
                width: "100%",
                maxWidth: "300px", // or whatever max width you prefer
                maxHeight: "90vh", // prevents modal from exceeding viewport height
                overflowY: "auto", // makes content scrollable if too tall
                borderRadius: "10px"
            }}
            onClick={(e) => e.stopPropagation()}
            >
            <h3>{selectedTransaction.title}</h3>
            <p>{selectedTransaction.description}</p>
            {selectedTransaction.quantity > 1 && <p>Quantity: {selectedTransaction.quantity}</p>}
            <hr />
            <h4>Dates</h4>
            <p>Purchased: {selectedTransaction.purchased_date}</p>
            <p>Sold: {selectedTransaction.sold_date}</p>
            <p>
                Duration: {Math.round((new Date(selectedTransaction.sold_date) - new Date(selectedTransaction.purchased_date)) / (1000 * 60 * 60 * 24))} days
            </p>
            <hr />
            <h4>Costs</h4>
            {selectedTransaction.quantity > 1 && <p>Cost: ${Number(selectedTransaction.cost).toFixed(2)} (per item)</p>}
            <p>Cost: ${Number(selectedTransaction.cost * selectedTransaction.quantity).toFixed(2)}</p>
            <hr />
            <h4>Sales</h4>
            {selectedTransaction.quantity > 1 && <p>Sell: ${Number(selectedTransaction.sell).toFixed(2)} (per item)</p>}
            {selectedTransaction.quantity > 1 && <p>Profit/Loss: ${Number(selectedTransaction.sell - selectedTransaction.cost).toFixed(2)} (per item)</p>}
            <p>Sell: ${Number(selectedTransaction.sell*selectedTransaction.quantity).toFixed(2)}</p>
            <p>Profit/Loss: ${Number((selectedTransaction.sell - selectedTransaction.cost)*selectedTransaction.quantity).toFixed(2)}</p>
            {selectedTransaction.notes && <>
                <hr />
                <h4>Notes</h4>
                <p>{selectedTransaction.notes}</p>
            </>}
            </div>
        </div>
        )}
    </div>
  );
}

export default Transactions;
